import { put, takeLatest, call, select } from 'redux-saga/effects';
import Strings, { validatebasketErrorCode } from '../constants/Strings';
import _ from 'lodash';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { CREATE_BASKETS_REQUEST, CREATE_BASKETS_SUCCESS, CREATE_BASKETS_FAILURE, ADD_ITEM_TO_CART, ADD_ITEM_TO_CART_SUCCESS, ADD_ITEM_TO_CART_FAILURE, DELETE_BASKET, DELETE_BASKET_SUCCESS, DELETE_BASKET_FAILURE, BASKET_DETAILS, BASKET_DETAILS_SUCCESS, BASKET_DETAILS_FAILURE, UPDATE_ITEM_QUANTITY, UPDATE_ITEM_QUANTITY_SUCCESS, UPDATE_ITEM_QUANTITY_FAILURE, REMOVE_LINE_ITEM, REMOVE_LINE_ITEM_SUCCESS, REMOVE_LINE_ITEM_FAILURE, REMOVE_All_ITEM, REMOVE_All_ITEM_SUCCESS, REMOVE_All_ITEM_FAILURE, CART_RECOMMENDATION_RULES, CART_RECOMMENDATION_RULES_SUCCESS, CART_RECOMMENDATION_RULES_FAILURE, GET_APPLICABLE_COUPONS, GET_APPLICABLE_COUPONS_SUCCESS, GET_APPLICABLE_COUPONS_FAILURE, APPLY_COUPONS, APPLY_COUPONS_SUCCESS, APPLY_COUPONS_FAILURE, REMOVE_COUPONS, REMOVE_COUPONS_SUCCESS, REMOVE_COUPONS_FAILURE, VALIDATE_BASKET_REQUEST, VALIDATE_BASKET_SUCCESS, VALIDATE_BASKET_FAILURE, RESET_CART_DATA, GET_NON_LOCALISED_COUPON, GET_NON_LOCALISED_COUPON_SUCCESS, GET_NON_LOCALISED_COUPON_FAILURE, GET_LOGGEDIN_NON_LOCALISED_COUPON, GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS, GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE, UPDATE_LINE_ITEM, REMOVE_ALL_COUPONS, REMOVE_ALL_COUPONS_SUCCESS, REMOVE_ALL_COUPONS_FAILURE, UPDATE_CUSTOMER_ID, UPDATE_CUSTOMER_ID_FAILURE, UPDATE_CUSTOMER_ID_SUCCESS, BULK_UPDATE_ITEM_QUANTITY, ITEM_UPDATED_TO_CART_SUCCESS, ITEM_UPDATED_TO_CART_ERROR, UNAVAILABLE_MODIFIERS, UPDATE_CART_WITH_STORE_AND_DISPOSITION, UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS, UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE, REMOVE_MULTIPLE_LINE_ITEM, } from '../constants';
import { storeClosedErrorCode, addCartErrorCode, storeDispositionsErrorCodes } from './../constants/Strings';
import { resetCartReducer } from '../redux/Actions/CartAction';
export function* createBasketsApiCall(request) {
    try {
        const { payload: { data, tenantId, successCallback, errorCallback }, } = request;
        const shouldAddItem = request?.payload?.shouldAddItem ? true : false;
        const addItemList = request?.payload?.addItemList || [];
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, _.get(networkConfig, Strings.createBaskets), {}, headers, data);
        if (status >= 400 && !storeClosedErrorCode.includes(response?.errorCode)) {
            yield put(setErrorCode(status));
        }
        if (response && response?.id) {
            yield put({
                type: CREATE_BASKETS_SUCCESS,
                response,
            });
            if (shouldAddItem) {
                yield put({
                    type: ADD_ITEM_TO_CART,
                    payload: {
                        params: { basketId: response.id },
                        tenantId,
                        shouldItemValidate: true,
                    },
                    postBody: addItemList,
                });
            }
            successCallback && successCallback();
        }
        else {
            yield put({
                type: CREATE_BASKETS_FAILURE,
                response,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        const errorCallback = _.get(request, 'payload.errorCallback');
        yield put({
            type: CREATE_BASKETS_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* createBasketsAction() {
    yield takeLatest(CREATE_BASKETS_REQUEST, createBasketsApiCall);
}
export function* deleteBasket(params) {
    try {
        const getTenant = (state) => state.tenantReducer;
        const tenantData = yield select(getTenant);
        const shouldCreateBasket = params?.shouldCreateBasket || false;
        const tempData = {
            queryProps: params?.payload,
        };
        const { response, status } = yield call(invokeApi, networkConfig.deleteBaskets, tempData, {
            'x-tenant-id': tenantData?.tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            yield put({
                type: DELETE_BASKET_SUCCESS,
                deleteBasketResponse: response,
            });
            if (shouldCreateBasket) {
                const createBasketParams = params?.createBasketParams || {};
                const { data = {}, tenantId = '' } = createBasketParams;
                yield put({
                    type: CREATE_BASKETS_REQUEST,
                    payload: { data, tenantId },
                });
            }
        }
        else {
            yield put({
                type: DELETE_BASKET_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: DELETE_BASKET_FAILURE,
        });
    }
}
export function* deleteBasketsSaga() {
    yield takeLatest(DELETE_BASKET, deleteBasket);
}
export function* addItemToCart(request) {
    const tenantId = request?.payload?.tenantId;
    const params = { queryProps: request?.payload?.params };
    const postBody = request?.postBody;
    const shouldItemValidate = !!request?.payload?.shouldItemValidate;
    const isFromReorder = request?.payload?.isFromReorder || false;
    // Need to be moved to common place
    const headers = {
        'x-tenant-id': tenantId,
    };
    const { response, status } = yield call(invokeApi, networkConfig.addItem, params, headers, postBody);
    if (status >= 400 && response?.errorCode !== addCartErrorCode) {
        yield put(setErrorCode(status));
    }
    const isValidResponse = response && response.id && response.foodLines?.length;
    // && response.validationResult?.overAll?.status; // currently this condition is failing for most of the products, keeping on hold for orderserv response.
    if (isValidResponse) {
        yield put({
            type: ADD_ITEM_TO_CART_SUCCESS,
            response,
        });
        if (shouldItemValidate) {
            yield put({
                type: VALIDATE_BASKET_REQUEST,
                payload: { data: { id: response.id }, tenantId },
            });
        }
        request?.successCallback && request.successCallback();
    }
    else {
        if (isFromReorder) {
            yield put(resetCartReducer());
        }
        yield put({
            type: ADD_ITEM_TO_CART_FAILURE,
            response,
        });
        request?.errorCallback && request.errorCallback();
    }
}
export function* getApplicableCoupons(request) {
    try {
        const params = { queryProps: request?.payload };
        const tenantId = request?.payload?.tenantId;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.applicableCoupons, params, headers);
        // Removed code regarding latest discussion on 1-Aug-2022 we have to ignore the error
        if (response?.length && _.isArray(response)) {
            yield put({
                type: GET_APPLICABLE_COUPONS_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_APPLICABLE_COUPONS_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_APPLICABLE_COUPONS_FAILURE,
        });
    }
}
export function* applyCouponAPICall(request) {
    try {
        const params = { queryProps: request?.payload };
        const tenantId = request?.payload?.tenantId;
        const postBody = request?.postBody;
        const successCallback = request?.payload?.successCallback;
        const errorCallback = request?.payload?.errorCallback;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.applyCoupon, params, headers, postBody);
        if (status >= 500) {
            yield put(setErrorCode(status));
        }
        if (response?.id) {
            yield put({
                type: APPLY_COUPONS_SUCCESS,
                response,
            });
            successCallback && successCallback();
        }
        else {
            yield put({
                type: APPLY_COUPONS_FAILURE,
                response,
            });
            errorCallback && errorCallback(response);
        }
    }
    catch (error) {
        yield put({
            type: APPLY_COUPONS_FAILURE,
            response: error?.response?.data,
        });
    }
}
export function* getApplicableCouponsActionSaga() {
    yield takeLatest(GET_APPLICABLE_COUPONS, getApplicableCoupons);
}
export function* applyCouponActionSaga() {
    yield takeLatest(APPLY_COUPONS, applyCouponAPICall);
}
export function* addItemToCartSaga() {
    yield takeLatest(ADD_ITEM_TO_CART, addItemToCart);
}
export function* basketDetails(params) {
    try {
        const queryData = {
            tenantId: params?.payload?.tenantId,
            basketId: params?.payload?.basketId,
        };
        const tempData = {
            queryProps: queryData,
        };
        const tenantId = params?.payload?.tenantId;
        const { response, status } = yield call(invokeApi, networkConfig.fetchCartDetails, tempData, {
            'x-tenant-id': tenantId,
        });
        const cartFlag = params?.payload?.cartFlag || false;
        if (status >= 400 && status !== 404) {
            if (cartFlag) {
                yield put(resetCartReducer());
            }
            else {
                yield put(setErrorCode(status));
            }
        }
        if (response?.id) {
            yield put({
                type: BASKET_DETAILS_SUCCESS,
                basketDetailsResponse: response,
            });
        }
        else {
            yield put({
                type: BASKET_DETAILS_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: BASKET_DETAILS_FAILURE,
        });
    }
}
export function* basketDetailsSaga() {
    yield takeLatest(BASKET_DETAILS, basketDetails);
}
export function* getRecommendationRules(request) {
    try {
        const { payload: { disposition, tenantId, channel }, flatResponse, } = request;
        // Need to be moved to common place
        const header = {
            'x-tenant-id': tenantId,
        };
        const tempData = {
            queryProps: { service: disposition, channel },
        };
        const { response, status } = yield call(invokeApi, networkConfig.recommendationsRules, tempData, header);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: CART_RECOMMENDATION_RULES_SUCCESS,
                recommendationRulesResponse: response,
                flatResponse,
            });
        }
        else {
            yield put({
                type: CART_RECOMMENDATION_RULES_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: CART_RECOMMENDATION_RULES_FAILURE,
        });
    }
}
export function* recommendationRulesSaga() {
    yield takeLatest(CART_RECOMMENDATION_RULES, getRecommendationRules);
}
export function* updateCustomerID(request) {
    try {
        const { payload } = request;
        const tenantId = payload?.tenantId;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.updateCustomerIdForBasket, { queryProps: { customerId: payload.customerId, basketId: payload.basketId } }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            yield put({
                type: UPDATE_CUSTOMER_ID_SUCCESS,
                response,
            });
            if (request?.payload?.postUpdateCallBack) {
                yield call(request?.payload?.postUpdateCallBack);
            }
        }
        else {
            yield put({
                type: UPDATE_CUSTOMER_ID_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_CUSTOMER_ID_FAILURE,
        });
    }
}
export function* updateCustomerIDForBasketSaga() {
    yield takeLatest(UPDATE_CUSTOMER_ID, updateCustomerID);
}
export function* updateItemQuantity(request) {
    try {
        const { isItemAdded } = request;
        const params = { queryProps: request?.payload?.params };
        const tenantId = request?.payload?.tenantId;
        const body = request?.postBody;
        const successCallback = request?.payload?.successCallback;
        const errorCallback = request?.payload?.errorCallback;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.updateQuantity, params, headers, body);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null && response.id && response.foodLines?.length) {
            yield put({
                type: UPDATE_ITEM_QUANTITY_SUCCESS,
                basketDetailsResponse: response,
                isItemAdded,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: UPDATE_ITEM_QUANTITY_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_ITEM_QUANTITY_FAILURE,
        });
    }
}
export function* updateItemQuantitySaga() {
    yield takeLatest(UPDATE_ITEM_QUANTITY, updateItemQuantity);
}
export function* updateLineItem(request) {
    const params = { queryProps: request?.payload?.params };
    const tenantId = request?.payload?.tenantId;
    const body = request?.postBody;
    const { successCallback, errorCallback } = request;
    const headers = {
        'x-tenant-id': tenantId,
    };
    try {
        const { response, status } = yield call(invokeApi, networkConfig.updateItem, params, headers, body);
        if (status >= 400 && response?.errorCode !== addCartErrorCode) {
            yield put(setErrorCode(status));
        }
        const basketLineItemIdVal = Array.isArray(params?.queryProps?.basketLineItemId)
            ? params?.queryProps?.basketLineItemId[0]
            : params?.queryProps?.basketLineItemId;
        const foodLinesUpdated = response &&
            response.foodLines?.map((val) => {
                let arrayItem = Object.assign({}, val);
                if (val.id === basketLineItemIdVal) {
                    arrayItem.editedItemId = basketLineItemIdVal;
                }
                return arrayItem;
            });
        const cartDataUpdated = { ...response, foodLines: foodLinesUpdated };
        const editedItemArray = cartDataUpdated.foodLines.filter((item) => item.editedItemId);
        const editedIdValue = editedItemArray[0]?.editedItemId;
        if (response && response?.id && response?.foodLines) {
            yield put({
                type: UPDATE_ITEM_QUANTITY_SUCCESS,
                basketDetailsResponse: cartDataUpdated,
                editedId: editedIdValue,
            });
            successCallback && successCallback();
            yield put({
                type: ITEM_UPDATED_TO_CART_SUCCESS,
            });
            //yield delay(2000);
            yield put({
                type: ITEM_UPDATED_TO_CART_ERROR,
            });
        }
        else {
            yield put({
                type: UPDATE_ITEM_QUANTITY_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (err) {
        yield put({
            type: UPDATE_ITEM_QUANTITY_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* updateLineItemSaga() {
    yield takeLatest(UPDATE_LINE_ITEM, updateLineItem);
}
export function* removeLineItem(params) {
    try {
        const tempData = {
            queryProps: params?.payload,
        };
        const tenantId = params?.payload?.tenantId;
        const successCallBack = params?.payload?.successCallBack;
        const { response, status } = yield call(invokeApi, networkConfig.remoteItem, tempData, {
            'x-tenant-id': tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            yield put({
                type: REMOVE_LINE_ITEM_SUCCESS,
                removeLineItemResponse: response,
                removedItemId: params?.payload?.basketLineItemId,
            });
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: REMOVE_LINE_ITEM_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_LINE_ITEM_FAILURE,
        });
    }
}
export function* removeLineItemSaga() {
    yield takeLatest(REMOVE_LINE_ITEM, removeLineItem);
}
export function* removeMultipleLineItem(params) {
    try {
        const tempData = {
            queryProps: params?.payload,
        };
        const body = params?.postBody;
        const tenantId = params?.payload?.tenantId;
        const successCallBack = params?.payload?.successCallBack;
        const { response, status } = yield call(invokeApi, networkConfig.removeMultipleItems, tempData, {
            'x-tenant-id': tenantId,
        }, body);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            yield put({
                type: REMOVE_LINE_ITEM_SUCCESS,
                removeLineItemResponse: response,
            });
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: REMOVE_LINE_ITEM_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_LINE_ITEM_FAILURE,
        });
    }
}
export function* removeMultipleLineItemSaga() {
    yield takeLatest(REMOVE_MULTIPLE_LINE_ITEM, removeMultipleLineItem);
}
export function* removeAllItem(params) {
    try {
        const successCallBack = params?.payload?.successCallBack;
        const tempData = {
            queryProps: params?.payload,
        };
        const tenantId = params?.payload?.tenantId;
        const { response, status } = yield call(invokeApi, networkConfig.clearCart, tempData, {
            'x-tenant-id': tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            yield put({
                type: REMOVE_All_ITEM_SUCCESS,
                removeAllItemResponse: response,
            });
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: REMOVE_All_ITEM_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_All_ITEM_FAILURE,
        });
    }
}
export function* removeAllItemSaga() {
    yield takeLatest(REMOVE_All_ITEM, removeAllItem);
}
export function* validateBasketApiCall(request) {
    try {
        const { payload: { data, tenantId }, successCallback, errorCallback, } = request;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, _.get(networkConfig, Strings.validateBasket), {}, headers, data);
        if (status >= 400 && !validatebasketErrorCode.includes(response?.errorCode)) {
            yield put(setErrorCode(status));
        }
        const isValidresponse = response && response.id && response.validationResult;
        if (isValidresponse) {
            yield put({
                type: VALIDATE_BASKET_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: VALIDATE_BASKET_FAILURE,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        const { errorCallback } = request;
        yield put({
            type: VALIDATE_BASKET_FAILURE,
        });
        errorCallback && errorCallback();
    }
}
export function* validateBasketSaga() {
    yield takeLatest(VALIDATE_BASKET_REQUEST, validateBasketApiCall);
}
export function* removeCouponAPICall(params) {
    try {
        const tempData = {
            queryProps: params?.payload,
        };
        const tenantId = params?.payload?.tenantId;
        const { successCallBack } = params;
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.removeCoupon, tempData, {
            'x-tenant-id': tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response?.id) {
            yield put({
                type: REMOVE_COUPONS_SUCCESS,
                removeCouponResponse: response,
            });
            successCallBack && successCallBack();
        }
        else {
            yield put({
                type: REMOVE_COUPONS_FAILURE,
                removeCouponResponse: response,
            });
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_COUPONS_FAILURE,
        });
    }
}
export function* removeAllCouponAPICall(request) {
    try {
        const tenantId = request?.payload?.tenantId;
        const params = { queryProps: request?.payload?.params };
        const postBody = request?.postBody;
        const shouldClearCart = request?.payload?.shouldClearCart || false;
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.removeAllCoupon, params, {
            'x-tenant-id': tenantId,
        }, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response?.id) {
            yield put({
                type: REMOVE_ALL_COUPONS_SUCCESS,
                removeAllCouponResponse: response,
            });
            if (shouldClearCart) {
                yield put({
                    type: REMOVE_All_ITEM,
                    payload: { tenantId, basketId: request?.payload?.params.basketId, successCallBack: request?.successCallBack },
                });
            }
        }
        else {
            yield put({
                type: REMOVE_ALL_COUPONS_FAILURE,
                removeAllCouponResponse: response,
            });
        }
    }
    catch (error) {
        yield put({
            type: REMOVE_ALL_COUPONS_FAILURE,
        });
    }
}
export function* getNonLocalisedCoupons(request) {
    try {
        const tenantId = request?.payload?.tenantId;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.nonLocalisedCoupon, null, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.length && _.isArray(response)) {
            yield put({
                type: GET_NON_LOCALISED_COUPON_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_NON_LOCALISED_COUPON_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_NON_LOCALISED_COUPON_FAILURE,
        });
    }
}
export function* getLoggedNonLocalizedCoupon(request) {
    try {
        const params = { queryProps: request?.payload };
        const tenantId = request?.payload?.tenantId;
        // Need to be moved to common place
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.cartCoupons.loggedInnonLocalisedCoupon, params, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        const isValidResponse = response?.length && _.isArray(response);
        if (isValidResponse) {
            yield put({
                type: GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE,
        });
    }
}
export function* removeCouponActionSaga() {
    yield takeLatest(REMOVE_COUPONS, removeCouponAPICall);
}
export function* resetCartToState() {
    yield put({
        type: RESET_CART_DATA,
    });
}
export function* resetCartToInitialStateSaga() {
    yield takeLatest(RESET_CART_DATA, resetCartToState);
}
export function* getNonLocalisedCouponsSaga() {
    yield takeLatest(GET_NON_LOCALISED_COUPON, getNonLocalisedCoupons);
}
export function* getLoggedinNonLocalizedCouponSaga() {
    yield takeLatest(GET_LOGGEDIN_NON_LOCALISED_COUPON, getLoggedNonLocalizedCoupon);
}
export function* removeAllCouponActionSaga() {
    yield takeLatest(REMOVE_ALL_COUPONS, removeAllCouponAPICall);
}
export function* bulkupdateItemQuantity(request) {
    try {
        let res = null;
        const { payload } = request;
        for (var req of payload) {
            const params = { queryProps: req?.params };
            const tenantId = req?.tenantId;
            const body = req?.postBody;
            const headers = {
                'x-tenant-id': tenantId,
            };
            const { response, status } = yield call(invokeApi, networkConfig.updateQuantity, params, headers, body);
            res = response;
            if (status >= 400) {
                break;
            }
            if (!res) {
                break;
            }
        }
        const isValidResponse = res && res !== undefined && res !== null && res.id && res.foodLines?.length;
        if (isValidResponse) {
            yield put({
                type: UPDATE_ITEM_QUANTITY_SUCCESS,
                basketDetailsResponse: res,
            });
        }
        else {
            yield put({
                type: UPDATE_ITEM_QUANTITY_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_ITEM_QUANTITY_FAILURE,
        });
    }
}
export function* bulkupdateItemQuantitySaga() {
    yield takeLatest(BULK_UPDATE_ITEM_QUANTITY, bulkupdateItemQuantity);
}
export function* updateStoreWithDispositionApiCall(request) {
    try {
        const { payload: { basketId, tenantId, postBody }, successCallback, } = request;
        // Need to be moved to common place
        const params = {
            queryProps: {
                basketId: basketId,
            },
        };
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.updateStoreAndDisposition, params, headers, postBody);
        if (status > 400 && !storeDispositionsErrorCodes.includes(response?.errorCode)) {
            // Removed code regarding latest discussion with POS on  1-Aug-2022 we have to ignore the status code 400
            yield put(setErrorCode(status));
        }
        if (storeDispositionsErrorCodes.includes(response?.errorCode) || response?.id) {
            yield put({
                type: UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS,
                response,
            });
            successCallback?.(response);
        }
        else {
            yield put({
                type: UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE,
            });
            if (status === 400) {
                yield put({
                    type: UNAVAILABLE_MODIFIERS,
                });
                // Removed code regarding latest discussion with POS  on 1-Aug-2022 we have to consider the status code 400 as success
                successCallback?.(response);
            }
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE,
        });
    }
}
export function* updateCartWithStoreAndDispositionSaga() {
    yield takeLatest(UPDATE_CART_WITH_STORE_AND_DISPOSITION, updateStoreWithDispositionApiCall);
}
